// Mock implementation of react-native-share for web
// This module is not used on web (the code uses direct download instead)
// but we need to provide a mock to prevent build errors

const RNShare = {
  Social: {
    FACEBOOK: "facebook",
    FACEBOOK_STORIES: "facebookstories",
    PAGESMANAGER: "pagesmanager",
    TWITTER: "twitter",
    WHATSAPP: "whatsapp",
    WHATSAPPBUSINESS: "whatsappbusiness",
    INSTAGRAM: "instagram",
    INSTAGRAM_STORIES: "instagramstories",
    GOOGLEPLUS: "googleplus",
    EMAIL: "email",
    PINTEREST: "pinterest",
    LINKEDIN: "linkedin",
    SMS: "sms",
    TELEGRAM: "telegram",
    MESSENGER: "messenger",
    SNAPCHAT: "snapchat",
    VIBER: "viber",
    DISCORD: "discord",
  },
  open: () => {
    console.warn("react-native-share is not supported on web")
    return Promise.reject(new Error("react-native-share is not supported on web"))
  },
  shareSingle: () => {
    console.warn("react-native-share is not supported on web")
    return Promise.reject(new Error("react-native-share is not supported on web"))
  },
  isPackageInstalled: () => {
    return Promise.resolve({ isInstalled: false, message: "Not supported on web" })
  },
}

export default RNShare
